/*
 * An object containing filter positions
 */
var CardFilterPosition = /** @class */ (function () {
    function CardFilterPosition() {
    }
    /**
     * Footer position
     */
    CardFilterPosition.FOOTER = 'footer';
    /**
     * Header position
     */
    CardFilterPosition.HEADER = 'header';
    return CardFilterPosition;
}());
export { CardFilterPosition };
//# sourceMappingURL=card-filter-position.js.map